/**
 * Manage cart update actions.
 *
 * DEPENDS ON:
 * - jQuery // Interact with WooCommerce events
 */
 (function (root, factory) {
	if ( typeof define === 'function' && define.amd ) {
		define([], factory(root));
	} else if ( typeof exports === 'object' ) {
		module.exports = factory(root);
	} else {
		root.CartUpdate = factory(root);
	}
})(typeof global !== 'undefined' ? global : this.window || this.global, function (root) {

	'use strict';

	var $ = jQuery;
	var _hasJQuery = ( $ != null );

	var _hasInitialized = false;
	var _publicMethods = {};
	var _settings = {
		bodyClass: 'has-fc-cart-update',

		wrapperSelector: '.fc-wrapper',
		sectionSelector: '.fc-cart-section',
		messagesWrapperSelector: '.woocommerce-notices-wrapper',

		sectionVisibleStateFieldSelector: '.fc-section-visible-state[type="hidden"]',
		sectionVisibleStateAttribute: 'data-section-visible',

		cartItemsListSelector: '.woocommerce-cart-form__contents tbody',
		cartItemNotRemovedSelector: '.woocommerce-cart-form__cart-item:not( .removed ):not( .undo )',

		uiProcessingClass: 'processing',

		shippingCalcMessagesWrapperSelector: '.fc-shipping-calculator-messages',

		scrollOffsetSelector: '.fc-checkout-header',
		scrollBehavior: 'smooth',
		scrollOffset: 0,

		updateCartFragmentsNonce: '', // Value updated during runtime
	}
	var _xhr = false;
	var _fragments = {};



	/**
	 * METHODS
	 */



	/*!
	* Merge two or more objects together.
	* (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
	* @param   {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
	* @param   {Object}   objects  The objects to merge together
	* @returns {Object}            Merged values of defaults and options
	*/
	var extend = function () {
		// Variables
		var extended = {};
		var deep = false;
		var i = 0;

		// Check if a deep merge
		if ( Object.prototype.toString.call( arguments[0] ) === '[object Boolean]' ) {
			deep = arguments[0];
			i++;
		}

		// Merge the object into the extended object
		var merge = function (obj) {
			for (var prop in obj) {
				if (obj.hasOwnProperty(prop)) {
					// If property is an object, merge properties
					if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
						extended[prop] = extend(extended[prop], obj[prop]);
					} else {
						extended[prop] = obj[prop];
					}
				}
			}
		};

		// Loop through each object and conduct a merge
		for (; i < arguments.length; i++) {
			var obj = arguments[i];
			merge(obj);
		}

		return extended;
    };



    /**
	 * Returns a function, that, as long as it continues to be invoked, will not
	 * be triggered. The function will be called after it stops being called for
	 * N milliseconds. If `immediate` is passed, trigger the function on the
	 * leading edge, instead of the trailing.
	 *
	 * @param   {[type]}  func       Function to be executed.
	 * @param   {[type]}  wait       Wait time in milliseconds.
	 * @param   {[type]}  immediate  Trigger the function on the leading edge.
	 *
	 * @return  function              Function to be executed, incapsulated in a timed function.
	 */
	var _debounce = function ( func, wait, immediate ) {
		var timeout;

		return function() {
		  var context = this, args = arguments;
		  var later = function() {
			timeout = null;
			if (!immediate) func.apply( context, args );
		  };

		  var callNow = immediate && !timeout;
		  clearTimeout( timeout );
		  timeout = setTimeout( later, wait );

		  if ( callNow ) func.apply( context, args );
		};
	};

	/**
	 * Get the offset position of the element recursively adding the offset position of parent elements until the `stopElement` (or the `body` element).
	 *
	 * @param   HTMLElement  element      Element to get the offset position for.
	 * @param   HTMLElement  stopElement  Parent element where to stop adding the offset position to the total offset top position of the element.
	 *
	 * @return  int                       Offset position of the element until the `stopElement` or the `body` element.
	 */
	var getOffsetTop = function( element, stopElement ) {
		var offsetTop = 0;
		
		while( element ) {
			// Reached the stopElement
			if ( stopElement && stopElement == element ) {
				break;
			}

			offsetTop += element.offsetTop;
			element = element.offsetParent;
		}
		
		return offsetTop;
	}




	/**
	 * Maybe change visibility status of cart sections.
	 *
	 * @param   Event  _event  An unused `jQuery.Event` object.
	 * @param   Array  data   The updated checkout data.
	 */
	var maybeChangeSectionState = function( _event, data ) {
		var sectionElements = document.querySelectorAll( _settings.sectionSelector );
		for ( var i = 0; i < sectionElements.length; i++ ) {
			var sectionElement = sectionElements[i];

			// Handle visibility state
			var visibilityHiddenField = sectionElement.querySelector( _settings.sectionVisibleStateFieldSelector );
			if ( visibilityHiddenField && 'no' === visibilityHiddenField.value ) {
				sectionElement.setAttribute( _settings.sectionVisibleStateAttribute, visibilityHiddenField.value );
			}
			else {
				sectionElement.removeAttribute( _settings.sectionVisibleStateAttribute );
			}
		}
	}



	/**
	 * Maybe set the focus back to the element with focus previously to fragments replacement.
	 *
	 * @param   HTMLElement  focusedElement  The current focused element.
	 * @param   mixed        value           Value for the current focused element.
	 */
	var maybeRefocusElement = function( focusedElement, value ) {
		// Bail if no element to focus
		if ( null === focusedElement ) { return; }

		requestAnimationFrame( function() {
			var elementToFocus;

			// Try findind the the current focused element after updating updated element by ID
			if ( focusedElement.id ) {
				elementToFocus = document.getElementById( focusedElement.id );
			}
			// Try findind the updated element by name
			else if ( focusedElement.getAttribute( 'name' ) ) {
				var nameAttr = focusedElement.getAttribute( 'name' );
				elementToFocus = document.querySelector( '[name="'+nameAttr+'"]' );
			}
			// Try findind the `select2` focusable element
			else if ( focusedElement.closest( '.form-row' ) ) {
				var formRow = focusedElement.closest( '.form-row' );
				if ( formRow.id ) {
					elementToFocus = document.querySelector( '.form-row[id="'+formRow.id+'"] .select2-selection' );
				}
			}

			// Try setting focus if element is found
			if ( elementToFocus ) {
				elementToFocus.focus();

				// Try to set current value to the focused element
				if ( null !== value && value !== elementToFocus.value ) {
					elementToFocus.value = value;
				}
				
				// Set keyboard track position back to that previously to update
				setTimeout( function(){
					// Try to set the same track position
					if( null !== elementToFocus.selectionStart && null !== elementToFocus.selectionEnd ) {
						if ( focusedElement.selectionStart && focusedElement.selectionEnd ) {
							elementToFocus.selectionStart = focusedElement.selectionStart;
							elementToFocus.selectionEnd = focusedElement.selectionEnd;
						}
						// Otherwise try set the track position to the end of the field
						// @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
						// @see https://html.spec.whatwg.org/multipage/input.html#concept-input-apply
						else {
							elementToFocus.selectionStart = elementToFocus.selectionEnd = Number.MAX_SAFE_INTEGER || 10000;
						}
					}
					// Try to select the entire content of the field
					// @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/select
					// @see https://html.spec.whatwg.org/multipage/input.html#concept-input-apply
					else {
						try { elementToFocus.select(); }
						catch { /* Do nothing */ }
					}
				}, 0 );
			}
		} );
	};



	/**
	 * Maybe trigger the update cart event when the page visibility state changes.
	 */
	var maybeUpdateCartVisibilityChange = function() {
		if ( 'hidden' == document.visibilityState || 'visible' == document.visibilityState ) {
			$( document.body ).trigger( 'wc_fragment_refresh' );
		}
	};



	/**
	 * Trigger update cart fragments for use with event handlers.
	 */
	var triggerUpdateCartFragments = function( e ) {
		_publicMethods.updateCartFragments();
	};



	/**
	 * Update the cart fragments.
	 * @throws  {TypeError}  Throws TypeError when used directly with event handlers because events pass the Event object as the first parameter while this function expects the first parameter to be the extra data to be sent with the AJAX request.
	 */
	_publicMethods.updateCartFragments = function( data ) {
		// Cancel existing update request
		if ( _xhr ) { _xhr.abort(); }

		// Add security
		data = extend( data, {
			security:   _settings.updateCartFragmentsNonce,
		} );

		_xhr = $.ajax({
			type:		'POST',
			url:		fcSettings.wcAjaxUrl.toString().replace( '%%endpoint%%', 'fc_pro_update_cart_fragments' ),
			data:		data,
			success:	function( result ) {

				// Reload the page if requested
				if ( result && true === result.reload ) {
					window.location.reload();
					return;
				}

				// Get current element with focus, will reset after updating the fragments
				var currentFocusedElement = document.activeElement;
				var currentValue = document.activeElement.value;

				// Always update the fragments
				if ( result && result.fragments ) {
					// Try to remove select2 components from existing fields before replacing fragments
					$( 'select.country_select, select.state_select' ).each( function() {
						var field = $( this );
						if ( field && false !== field.data( 'select2' ) && field.selectWoo && 'function' === typeof field.selectWoo ) {
							try {
								field.select2( 'destroy' );
							} catch ( error ) {
								try { field.selectWoo( 'destroy' ); }
								catch ( error2 ) { /* Do nothing */ }
							}
						}
					});

					$.each( result.fragments, function ( key, value ) {
						// CHANGE: Declare local variables needed for some checks before replacing the fragment
						var fragmentToReplace = document.querySelector( key );
						var replaceFragment = true;

						// CHANGE: Allow fragments to be replaced every time even when their contents are equal the existing elements in the DOM
						if ( value && -1 !== value.toString().indexOf( 'fc-fragment-always-replace' ) ) {
							replaceFragment = true;
						}
						
						// CHANGE: Allow fragments to be replaced every time even when their contents are equal the existing elements in the DOM
						if ( replaceFragment && ( ! _fragments || _fragments[ key ] !== value ) ) {
							$( key ).replaceWith( value );
						}
						$( key ).unblock();
					} );
					_fragments = result.fragments;
				}

				// Re-set focus to the element with focus previously to updating fragments
				maybeRefocusElement( currentFocusedElement, currentValue );

				// Maybe scroll to notices
				var messagesWrapper = document.querySelector( _settings.messagesWrapperSelector );
				if ( messagesWrapper && messagesWrapper.children.length > 0 ) {
					_publicMethods.scrollToNotices( messagesWrapper );
				}

				$( document.body ).trigger( 'wc_fragments_refreshed' );
				$( document.body ).trigger( 'updated_cart_totals' );
			}

		});
	};



	/**
	 * Change scroll position after changing steps.
	 */
	_publicMethods.scrollToNotices = function() {
		var element = document.querySelector( _settings.messagesWrapperSelector );
		var stickyElementsOffset = 0;

		// Maybe add sticky elements height to scroll position
		if ( window.StickyStates ) {
			var maybeStickyElements = document.querySelectorAll( _settings.scrollOffsetSelector );
			if ( maybeStickyElements && maybeStickyElements.length > 0 ) {
				for ( var i = 0; i < maybeStickyElements.length; i++ ) {
					var stickyElement = maybeStickyElements[i];
					if ( StickyStates.isStickyPosition( stickyElement ) ) {
						var height = stickyElement.getBoundingClientRect().height;
						stickyElementsOffset += height;
					}
				}
			}
		}

		// Scroll to the top of the collapsed step
		var elementOffset = getOffsetTop( element ) + ( _settings.scrollOffset * -1 ) + ( stickyElementsOffset * -1 );
		requestAnimationFrame( function() {
			window.scrollTo( {
				top: elementOffset,
				behavior: _settings.scrollBehavior,
			} );
		} );
	}

	

	/**
	 * Use the same method that WooCommerce uses to block other parts of the checkout form while updating.
	 * The UI is unblocked by the WooCommerce `checkout.js` script (which is replaced with a modified version but keeps the same behavior)
	 * using the checkout fragment selector, then unblocking after the checkout update is completed.
	 *
	 * @param   HTMLElement  element  Element to block the UI and show the loading indicator.
	 */
	_publicMethods.blockUI = function( element ) {
		$( element ).addClass( _settings.uiProcessingClass ).block( {
			message: null,
			overlayCSS: {
				background: '#fff',
				opacity: 0.6
			}
		} );
	}

	/**
	 * Unblock UI element to be used again.
	 *
	 * @param   HTMLElement  element  Element to get the UI unblocked.
	 *
	 * @see  blockUI
	 */
	_publicMethods.unblockUI = function( element ) {
		$( element ).removeClass( _settings.uiProcessingClass ).unblock();
	}

	/**
	 * Add notices in the coupon code section.
	 *
	 * @param   HTML  content  HTML content to be displayed.
	 */
	 _publicMethods.showShippingNotices = function( content ) {
		var messagesWrapper = document.querySelector( _settings.shippingCalcMessagesWrapperSelector );
		if ( messagesWrapper ) {
			messagesWrapper.innerHTML = content;
		}
	}

	/**
	 * Remove all notices from the coupon code section.
	 *
	 * @param   HTML  content  HTML content to be displayed.
	 */
	_publicMethods.clearShippingNotices = function() {
		var messagesWrapper = document.querySelector( _settings.shippingCalcMessagesWrapperSelector );
		if ( messagesWrapper ) {
			messagesWrapper.innerHTML = '';
		}
	}



	/**
	 * Initialize component and set related handlers.
	 */
	_publicMethods.init = function( options ) {
		if ( _hasInitialized ) return;

		// Merge settings
		_settings = extend( _settings, options );

		// Add event listeners
		document.addEventListener( 'visibilitychange', maybeUpdateCartVisibilityChange );

		// Add jQuery event listeners
		if ( _hasJQuery ) {
			$( document.body ).on( 'wc_fragment_refresh updated_wc_div updated_shipping_method', triggerUpdateCartFragments );
			
			// After cart fragments has been updated
			$( document.body ).on( 'wc_fragments_refreshed', maybeChangeSectionState );
		}

		// Add init class
		document.body.classList.add( _settings.bodyClass );

		// Update fragments
		triggerUpdateCartFragments();

		_hasInitialized = true;
	};



	//
	// Public APIs
	//
	return _publicMethods;

});
